import { Card, CardBody } from "@heroui/react";
import clsx from "clsx";

import { IconComponent } from "@/types/common";

interface ActionCardProps {
  icon: IconComponent;
  label: string;
  onPress: () => void;
}

export function ActionCard({ icon: Icon, label, onPress }: ActionCardProps) {
  return (
    <Card
      isPressable
      onPress={onPress}
      className={clsx(
        "col-span-1 h-16 rounded-full transition-all duration-300 sm:col-span-1",
        "dark:from-content1 bg-linear-to-br from-white to-neutral-100 dark:via-neutral-900 dark:to-neutral-950",
        "ring-1 ring-neutral-200 hover:ring-neutral-300 dark:ring-neutral-700/50 dark:hover:ring-neutral-600/80",
        "hover:scale-105 hover:shadow-md hover:shadow-neutral-200/60 active:scale-95 dark:hover:shadow-lg dark:hover:shadow-neutral-900/50"
      )}
    >
      <CardBody className="flex flex-row items-center justify-center gap-4">
        <Icon className="text-2xl transition-transform duration-300 group-hover:scale-110" />
        <div className="text-center">
          <span className="text-lg font-semibold text-neutral-900 dark:text-neutral-50">{label}</span>
        </div>
      </CardBody>
    </Card>
  );
}
